// Mobile Product Page Reordering Script
// Cleanly reorganizes product page elements for mobile
// Order: Title -> Rating -> Price -> Images -> Add to Cart

(function() {
  'use strict';
  
  function reorderForMobile() {
    // Only run on mobile and product pages
    if (window.innerWidth > 749 || !window.location.pathname.includes('/products/')) {
      return;
    }
    
    // Check if already reordered
    if (document.querySelector('.mobile-product-layout')) {
      return;
    }
    
    // Wait for page to fully load
    setTimeout(function() {
      const productGrid = document.querySelector('[class*="product-grid"]');
      if (!productGrid) return;
      
      const metaSection = document.querySelector('.product-meta-section');
      const gallerySection = document.querySelector('.product-gallery-section');
      
      if (!metaSection || !gallerySection) return;
      
      // Find specific elements and MOVE them (not clone)
      // Look for the h1 title first, then fall back to b-title block
      const h1Title = metaSection.querySelector('h1');
      const title = metaSection.querySelector('[id*="b-title"]');
      const rating = metaSection.querySelector('[id*="loox-rating"]');
      const price = metaSection.querySelector('[id*="b-price"]');
      const variantSelector = metaSection.querySelector('[id*="7e37f69f"]');
      // The buy-buttons block (#b-buttons) is rendered INSIDE the product
      // <form action="/cart/add"> (see snippets/product-form.liquid). Moving
      // the block alone tore it out of that form: the "Add to cart" button
      // then had no owning form, so tapping it only toggled the spinner and
      // never submitted. Move the form itself so the button stays inside it.
      const buyButtonsBlock = metaSection.querySelector('[id*="b-buttons"]');
      const buyButtons = buyButtonsBlock
        ? (buyButtonsBlock.closest('form[action*="/cart/add"]') || buyButtonsBlock)
        : null;
      const stockAlert = metaSection.querySelector('[id*="stock_alert"]');
      const pickupAvail = metaSection.querySelector('[id*="pickup_availability"]');
      
      // Create new mobile container
      const mobileContainer = document.createElement('div');
      mobileContainer.className = 'mobile-product-layout';
      mobileContainer.style.cssText = 'display: flex; flex-direction: column; width: 100%;';
      
      // Create top section (title, rating, price)
      const topSection = document.createElement('div');
      topSection.className = 'mobile-top-section';
      topSection.style.cssText = 'padding: 1rem; background: white;';
      
      // MOVE elements to top section (not clone)
      // Add h1 title first if it exists
      if (h1Title) {
        h1Title.style.fontSize = '1.5rem';
        h1Title.style.marginBottom = '0.5rem';
        topSection.appendChild(h1Title);
      } else if (title) {
        topSection.appendChild(title);
      }
      
      if (rating) {
        topSection.appendChild(rating);
      }

      // NOTE: price intentionally NOT added to topSection — client item 37
      // asked to move price back below the product image. It gets appended
      // to the bottomSection (below gallery) further down instead.

      // MOVE gallery section
      const galleryWrapper = document.createElement('div');
      galleryWrapper.className = 'mobile-gallery-wrapper';
      galleryWrapper.style.cssText = 'width: 100%;';
      galleryWrapper.appendChild(gallerySection);

      // Create bottom section (price, variant, add to cart, etc)
      const bottomSection = document.createElement('div');
      bottomSection.className = 'mobile-bottom-section';
      bottomSection.style.cssText = 'padding: 1rem; background: white;';

      // Price first in bottom section so it reads immediately below the image
      if (price) {
        bottomSection.appendChild(price);
      }

      // MOVE action elements to bottom section
      if (variantSelector) {
        bottomSection.appendChild(variantSelector);
      }
      
      if (buyButtons) {
        bottomSection.appendChild(buyButtons);
      }
      
      if (stockAlert) {
        bottomSection.appendChild(stockAlert);
      }
      
      if (pickupAvail) {
        bottomSection.appendChild(pickupAvail);
      }
      
      // MOVE remaining meta items
      while (metaSection.firstChild) {
        bottomSection.appendChild(metaSection.firstChild);
      }
      
      // Assemble mobile layout
      mobileContainer.appendChild(topSection);
      mobileContainer.appendChild(galleryWrapper);
      mobileContainer.appendChild(bottomSection);
      
      // Replace the grid with mobile container
      productGrid.parentNode.replaceChild(mobileContainer, productGrid);
      
      // Re-initialize any JavaScript that might be needed
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
    }, 500);
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderForMobile);
  } else {
    reorderForMobile();
  }
  
  // Handle browser back/forward
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      reorderForMobile();
    }
  });
})();